import type { MapInteractiveProps } from "./map-interactive.type";

import { Map } from "@vis.gl/react-google-maps";
import classNames from "classnames";

import { MapGeojson } from "../map-geojson";
import MapMarkers from "../map-markers";
import { MapTile } from "../map-tile";

import { useMapInteractive } from "./map-interactive.hook";

const MapInteractive = (props: MapInteractiveProps) => {
  const {
    markers,
    mapProps,
    id,
    geojson,
    geojsonOptions,
    noInfoWindow,
    className,
  } = useMapInteractive(props);

  return (
    <div key={id} className={classNames("map-interactive", className)}>
      <Map {...mapProps}>
        <MapTile />
        <MapMarkers mapId={id} markers={markers} noInfoWindow={noInfoWindow} />
        <MapGeojson geojson={geojson} options={geojsonOptions} />
      </Map>
    </div>
  );
};

export default MapInteractive;
